import index from "./register.vue";
export default index;
